export default "__VITE_ASSET__Cdleynph__"